import React from 'react'
import type { FC } from 'react'
import { NativeProps, withNativeProps } from '@utils/NativeProps'

export const ThumbIcon: FC<NativeProps> = props => withNativeProps(
  props,
  <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>编组 8</title>
    <g id="按钮" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="滑动输入条" transform="translate(-21.000000, -515.000000)">
        <g id="编组备份-4" transform="translate(0.000000, 494.000000)">
          <g id="编组-4" transform="translate(16.000000, 16.000000)">
            <g id="编组-8" transform="translate(5.000000, 5.000000)">
              <rect id="矩形" x="0" y="0" width="14" height="14"></rect>
              <g id="编组-7" transform="translate(4.000000, 1.000000)"  fill='currentColor' fillRule='evenodd'>
                <rect id="矩形" x="0" y="0" width="1.5" height="12" rx="0.75"></rect>
                <rect id="矩形备份" x="4.5" y="0" width="1.5" height="12" rx="0.75"></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
